import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Avatar from '../common/Avatar';
import Icon from '../common/Icon';
import { useAuth } from '../../hooks/useAuth';

function firstName(name = '') {
  return name.split(' ')[0] || name;
}

function UserMenu() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () =>
      document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = async () => {
    setOpen(false);
    await logout();
    navigate('/login', { replace: true });
  };

  if (!user) {
    return null;
  }

  return (
    <div className="topbar-user-section">
      <div className="user-menu" ref={menuRef}>
        <button
          type="button"
          className="user-menu-trigger"
          onClick={() => setOpen((v) => !v)}
          aria-haspopup="menu"
          aria-expanded={open}
          aria-label={`Open account menu for ${user.full_name}`}
        >
          <Avatar user={user} className="avatar avatar-sm" />
          <span className="user-menu-copy">
            <span className="user-menu-name">{firstName(user.full_name)}</span>
            <span className="user-menu-role">{user.role || 'workspace'}</span>
          </span>
          <Icon name="chevron-down" size={15} />
        </button>

      {open && (
        <div className="user-menu-dropdown" role="menu">
          <div className="user-menu-header">
            <Avatar user={user} className="avatar" />
            <span>
              <span className="user-menu-name">{user.full_name}</span>
              <span className="user-menu-email">{user.email}</span>
            </span>
          </div>
          <button
            type="button"
            className="user-menu-item"
            onClick={() => {
              setOpen(false);
              navigate('/app/settings');
            }}
          >
            <Icon name="settings" size={16} />
            Settings
          </button>

          <div className="user-menu-divider" />

          <button
            type="button"
            className="user-menu-item"
            onClick={handleLogout}
          >
            <Icon name="logout" size={16} />
            Logout
          </button>
        </div>
      )}
      </div>
    </div>
  );
}

export default UserMenu;
